import React from 'react';
import { Form } from 'react-bootstrap';

import { CreateUpdateStageHintDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import FormRow from '../../../app/components/FormRow';
import StageSelector from '../Selects/StageSelector';
import { useTranslation } from '../../../translations';
import { TimelineHintDeadlineEnum } from '../../../common/pokCore/validation/enums';
import DeadLineSelector from '../Selects/DeadLineSelector';

interface HintEditorFormProps {
  hint: CreateUpdateStageHintDto;
  propertyChange: (obj: Partial<CreateUpdateStageHintDto>) => void;
  readOnly?: boolean;
}

export const HintEditorForm: React.FC<HintEditorFormProps> = props => {
  const { t, tk } = useTranslation('projectLng');
  return (
    <Form className="d-grid gap-3">
      <FormRow controlId="stageSelector" label={t(tk.timeLine.stage)}>
        <StageSelector
          value={props.hint?.stageDefinitionId || ''}
          onChange={option =>
            props.propertyChange({ stageDefinitionId: option.value })
          }
          readOnly={props.readOnly}
        />
      </FormRow>

      <FormRow controlId="descriptionPl" label={t(tk.timeLine.hintText)}>
        <Form.Control
          as="textarea"
          rows={2}
          value={props.hint?.descriptionPl || ''}
          onChange={e =>
            props.propertyChange({ descriptionPl: e.target.value })
          }
          disabled={props.readOnly}
        />
      </FormRow>

      <FormRow controlId="descriptionEn" label={t(tk.timeLine.hintTextEn)}>
        <Form.Control
          as="textarea"
          rows={2}
          value={props.hint?.descriptionEn || ''}
          onChange={e =>
            props.propertyChange({ descriptionEn: e.target.value })
          }
          disabled={props.readOnly}
        />
      </FormRow>
      {/* <FormRow controlId="url" label={t(tk.timeLine.url)}>
        <Form.Control
          type="text"
          value={props.hint?.url || ''}
          onChange={e => props.propertyChange({ url: e.target.value || null })}
          disabled={props.readOnly}
        />
      </FormRow> */}
      <FormRow controlId="deadline" label={t(tk.timeLine.deadline)}>
        <DeadLineSelector
          deadline={props.hint?.deadline as TimelineHintDeadlineEnum}
          readOnly={props.readOnly}
          onChange={option =>
            props.propertyChange({
              deadline: (option
                ? option.value
                : null) as TimelineHintDeadlineEnum,
            })
          }
        />
      </FormRow>
      <FormRow controlId="order" label={t(tk.timeLine.order)}>
        <Form.Control
          type="number"
          value={props.hint?.order ?? 0}
          onChange={e =>
            props.propertyChange({ order: parseInt(e.target.value, 10) || 0 })
          }
          disabled={props.readOnly}
        />
      </FormRow>

      <FormRow controlId="active" label={t(tk.common.activeShe)}>
        <Form.Check
          type="checkbox"
          className="pt-2"
          checked={props.hint?.active ?? true}
          onChange={e => props.propertyChange({ active: e.target.checked })}
          disabled={props.readOnly}
        />
      </FormRow>
    </Form>
  );
};
